import { useCallback, useState } from 'react';
import { FETCH_UNSETTLEMENTS_PER_PAGE_COUNT } from '@bo-constants/unsettlements';
import { useGetUnsettlementsActionsQuery } from '@bo-services/unsettlementsApi';

export const useUnsettlementsActions = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const handleCurrentPageChange = useCallback(() => {
    setCurrentPage((prevPage) => prevPage + 1);
  }, []);

  const handleResetCurrentPage = useCallback(() => {
    setCurrentPage(1);
  }, []);

  const {
    data: response,
    isFetching,
    isError,
    isLoading,
    isSuccess
  } = useGetUnsettlementsActionsQuery({
    page: currentPage,
    perPage: FETCH_UNSETTLEMENTS_PER_PAGE_COUNT
  });

  const {
    currentPage: currentPageResponse = 0,
    data = [],
    totalPages = 0
  } = response || {};

  const isUnsettlementsFetching = isFetching && currentPage === 1;

  return {
    currentPage: currentPageResponse,
    data,
    handleCurrentPageChange,
    handleResetCurrentPage,
    isError,
    isFetching: isUnsettlementsFetching,
    isLoading,
    isSuccess,
    totalPages
  };
};
